import React, { ChangeEventHandler, MouseEventHandler } from 'react';
import { connect, ResolveThunks } from 'react-redux';
import FileUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, IconButton, Tooltip } from '@mui/material';

import {
  extractUploadedFilesFromZip,
  FileFromBrowserUpload,
  processFiles,
  UploadedFile,
} from '@paragon/component-processor';
import { enqueueError, enqueueInfo } from '@paragon/notification-tools';

import { showFileManagerPopup } from '../../actions/popup';
import { jobIsLocked } from '../../modules/jobLocking';

type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = DispatchProps;

class AddItems extends React.Component<Props> {
  onChooseFiles: MouseEventHandler<HTMLInputElement> = async (event) => {
    // TODO Is this correct?
    // Clear out any files selected by a previous use of this file input
    (event.target as any).value = null;

    if (jobIsLocked()) {
      event.preventDefault();
    }
  };

  onAddDocuments: ChangeEventHandler<HTMLInputElement> = async (event) => {
    if (event.target.files!.length === 0) {
      return;
    }

    try {
      let uploadedFiles: readonly UploadedFile[] = FileFromBrowserUpload.fromList(event.target.files!);

      if (uploadedFiles.length === 1 && uploadedFiles[0].filetype === 'zip') {
        uploadedFiles = await extractUploadedFilesFromZip(await uploadedFiles[0].getContents());
      }

      const processedFiles = await processFiles(uploadedFiles, [], false);
      this.props.showFileManager(processedFiles);
    } catch (err) {
      console.error(err);
    }
  };

  render() {
    return (
      <div>
        <Box
          component="input"
          sx={{ display: 'none' }}
          type="file"
          id="icon-button-file"
          onClick={this.onChooseFiles}
          onChange={this.onAddDocuments}
          multiple
        />
        <Tooltip disableInteractive disableFocusListener id="add-items-tooltip" title="Add Items">
          <IconButton sx={{ borderRadius: 0 }}>
            <Box component="label" htmlFor="icon-button-file" sx={{ display: 'flex' }}>
              <FileUploadIcon />
            </Box>
          </IconButton>
        </Tooltip>
      </div>
    );
  }
}

const actionCreators = {
  showFileManager: showFileManagerPopup,
  enqueueError,
  enqueueInfo,
};

export default connect(null, actionCreators)(AddItems);
